<template>
  <div class="add-crew">
    <div class="d-flex justify-content-between align-items-center">
      <h2 class="title">Add Crew</h2>
      <div class="ico" @click="closeAddCrew">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
            fill="#474D52"
          />
        </svg>
      </div>
    </div>
    <button @click="showAddPopup" class="btn btn-primary btn-sm collapsed">
      +Add New Crew
    </button>
    <div class="select_crew">
      or select an existing crew
    </div>
    <div class="crew-list">
      <div
        class="crew-member"
        v-for="(crew, n) in crews"
        :key="n"
        @click="toogleCrew(crew)"
        :class="{ active: activeCrew.indexOf(crew) >= 0 }"
      >
        <div class="info">
          <div>
            <h4 class="headline" v-if="crew.subtext">{{ crew.subtext }}</h4>

            <img v-if="crew.imgURL" :src="crew.imgURL" alt="" />
            <b-avatar v-else></b-avatar>

            <h3>{{ crew.text }}</h3>
          </div>
        </div>
        <span
          class="ico"
          v-if="activeCrew.indexOf(crew) < 0"
          v-b-tooltip.hover
          title="Add Crew"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#557EFB" fill-opacity="0.1" />
            <path
              d="M12.0005 6V18.857"
              stroke="#557EFB"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M5 12.4287L19 12.4287"
              stroke="#557EFB"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <span class="ico" v-else v-b-tooltip.hover title="Remove Crew">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#557EFB" fill-opacity="0.1" />
            <path
              d="M4 13.875L8.09091 18L19 7"
              stroke="#557EFB"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
      </div>
    </div>
    <add-cew-popup
      @addCrew="addCrew"
      ptitle="Add Crew"
      v-if="show.addPopup"
    ></add-cew-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddCewPopup from "@/components/dashcard/components/AddCewPopup";
export default {
  props: {
    addPopup: Boolean,
    currentCrews: Array
  },
  data() {
    return {
      show: {
        addPopup: this.addPopup
      },
      crews: [],
      activeCrew: []
    };
  },
  computed: {
    ...mapGetters({
      crewList: "user/listNames"
    })
  },
  components: {
    AddCewPopup
  },
  watch: {
    addPopup(newval) {
      this.show.addPopup = newval;
    }
  },
  mounted() {
    this.crewList.forEach(crew => {
      let crewmember = {
        text: crew.info.firstname + " " + crew.info.lastname,
        email: crew.info.email || ""
      };
      this.crews.unshift(crewmember);
    });
    this.currentCrews.forEach(crew => {
      this.activeCrew.push(crew);
    });
    console.log(this.crews);
    console.log(this.activeCrew);
    console.log(this.currentCrews);
  },
  methods: {
    toogleCrew(crew) {
      console.log(crew);
      let current_index = this.activeCrew.indexOf(crew);
      console.log(current_index);
      if (current_index >= 0) {
        this.activeCrew.splice(current_index, 1);
      } else {
        this.activeCrew.push(crew);
      }
      console.log(this.activeCrew);
      this.$emit("updateCrews", this.activeCrew);
    },
    addCrew(crew) {
      let uid = this.checkIsNameOnDb();
      let crewmember = {
        _created_at: new Date(),
        text: crew.name,
        subText: crew.role,
        email: crew.email,
        uid: uid === 0 || uid > -1 ? uid : undefined
      };
      this.crews.unshift(crewmember);
      this.activeCrew.push(crewmember);
      this.show.addPopup = false;
      this.$emit("toogleAddPopup");
    },
    showAddPopup() {
      this.$emit("toogleAddPopup");
    },
    closeAddCrew() {
      this.$emit("closeAddCrew", this.activeCrew);
    },
    checkIsNameOnDb() {
      let existingNames = this.$store.getters["user/listNames"].map(
        el =>
          `${el.info.firstname +
            (el.info.lastname ? " " + el.info.lastname : "")}`
      );
      if (existingNames.includes(this.crewNameInputText)) {
        return this.$store.getters["user/listNames"][
          existingNames.indexOf(this.crewNameInputText)
        ].uid;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ico {
  cursor: pointer;
}
.add-crew {
  padding: 24px;
  position: relative;
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
    margin: 0;
  }
  .btn.collapsed {
    padding: 11px;
    width: 100%;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
    border-radius: 8px;
    margin-top: 23px;
  }
  .select_crew {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #8d99a0;
    text-align: center;
    margin-top: 16px;
  }
  .crew-list {
    margin-top: 16px;
    .crew-member {
      margin-bottom: 4px;
      border-radius: 8px;
      cursor: pointer;
      position: relative;
      &.active {
        background: rgba(85, 126, 251, 0.1);
      }
      .ico {
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        cursor: pointer;
      }
      .headline {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #8d99a0;
        margin-bottom: 4px;
      }
      .info {
        padding: 8px 16px;
        display: grid;
        grid-template-columns: 1fr 25px;
        align-items: center;
        img {
          width: 25px;
          height: 25px;
          object-fit: cover;
          border-radius: 50%;
        }
        h3 {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 22px;
          color: #474d52;
          margin: 0 0 0 10px;
          display: inline-block;
        }
        .ico {
          cursor: pointer;
          //   display: none;
          //   transition: all 0.4s linear;
        }
      }
    }
  }
  .add-crew-popup {
    width: 328px;
    height: 307px;
    position: absolute;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    background-color: #fff;
    top: 25%;
    right: 0;
    padding: 24px 16px;
    z-index: 3;
    .title {
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
    }
  }
}
</style>
